import styled from 'styled-components';
import BodyTextBlock from '@carvana/showroom-content/TextBlock/Body';
import Spinner from '@carvana/showroom-spinner';
import { getMediaQuery } from '@carvana/showroom-theme';

import { Section, InnerSection } from '../../../../styles/section/section';

export const StyledSection = styled(Section)`
  padding-top: 0;
  ${(props) => getMediaQuery(props.theme.breakpoint.md)} {
    padding-top: 2rem
  }
`;

export const StyledSectionInner = styled(InnerSection)`
  padding-top: 0;
`;

export const StyledMessage = styled(BodyTextBlock)`
  font-size: 0.875rem;
  margin-bottom: 2rem;
  color: ${({ theme }) => theme.carvana.gray.dark};
`;

export const StyledSpinner = styled(Spinner)`
  ${(props) => getMediaQuery(props.theme.breakpoint.sm)} {
    justify-content: flex-start;
  }
`;
